export const NUMBER_REGEX = /[0-9]/;
export const LOWERCASE_REGEX = /[a-z]/;
export const UPPERCASE_REGEX = /[A-Z]/;
export const SYMBOL_REGEX = /[!@#$%^&*(),.?":{}|<>]/;
